import starFill from '@iconify/icons-eva/star-fill';
import { Icon } from '@iconify/react';
import { SvgIcon } from '@material-ui/core';
import React from 'react';

// ----------------------------------------------------------------------

const ICON_SMALL = { height: 20, width: 20 };
const ICON_LARGE = { height: 28, width: 28 };

const ICON = (
  <SvgIcon>
    <Icon icon={starFill} />
  </SvgIcon>
);

export default function Rating(theme) {
  return {
    MuiRating: {
      defaultProps: {
        emptyIcon: ICON,
        icon: ICON,
      },

      styleOverrides: {
        iconEmpty: { color: theme.palette.grey[500_48] },
        root: {
          '&.Mui-disabled': {
            opacity: 0.48,
          },
        },
        sizeLarge: { '& svg': { ...ICON_LARGE } },
        sizeSmall: { '& svg': { ...ICON_SMALL } },
      },
    },
  };
}
